import { JsonConverter, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo } from "../../base-types";
import { AggregatedEntityRelationsConverter } from "../../converters/aggregated-entity-relations-converter";
import { EntityResource } from "../entity-resource";
import { RelationResource } from "../relation-resource";

export interface IAggregatedEntityResource {
    entity: EntityResource;

    relations: MapStringTo<RelationResource>;
}

@JsonObject()
export class AggregatedEntityResource implements IAggregatedEntityResource {
    @JsonProperty("entity")
    entity: EntityResource;

    @JsonProperty("relations")
    @JsonConverter(AggregatedEntityRelationsConverter)
    relations: MapStringTo<RelationResource>;
}
